/** Hides the boot splash rendered by `index.html`. */
export const hideAppSplash = (): void => {
  const splash = document.getElementById("app-splash");
  if (!splash) return;

  splash.classList.add("is-hidden");
  splash.addEventListener("transitionend", () => splash.remove(), { once: true });

  // `transitionend` never fires when the element isn't rendered (background tab,
  // reduced motion), leaving the node stuck on top of the app.
  setTimeout(() => splash.remove(), 500);
};
